// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"871":"6613f30a","887":"0f81404d"}[chunkId] + ".chunk.js";
};